import '../stylesheets/styles.scss';
import './components/ai.scss';

import 'core-js';

import 'bootstrap-italia';
// import 'select2';

import './utils/imagesConfig';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';

import { PageData, Cookies, Keyboard, Logger, Responsive, Translations } from './utils'; // eslint-disable-line object-curly-newline
import { asyncSVG } from './libs/asyncSVG';
import { Header } from './components/header';
import { Footer } from './components/footer';
import { CookiePreferences } from './components/cookie-preferences';
import { Page } from './components/page';
import { Pagination } from './components/pagination';
import { Breadcrumbs } from './components/breadcrumbs';
import { Hero } from './components/hero';
import { Card } from './components/card';
import { NewsEvidenza } from './components/news-evidenza';
import { TwoColumns } from './components/two-columns';
import { ContentWrapper } from './components/content-wrapper';
import { MediaWrapper } from './components/media-wrapper';
import { InEvidenza } from './components/in-evidenza';
import { Faq } from './components/faq';
import { StorieSlider } from './components/storie-slider';
import { Banner } from './components/banner';
import { Multistep } from './components/multistep';
import { Numbers } from './components/numbers';
import { OneColumn } from './components/one-column';
import { DettaglioNews } from './components/dettaglio-news';
import { NewsDate } from './components/news-date';
import { NewsHeader } from './components/news-header';
import { Cifre } from './components/cifre';
import { ShareOn } from './components/share-on';
import { CompositionBlock } from './components/composition-block';
import { CalendarCard } from './components/calendar-card';
import { Newsletter } from './components/newsletter';
import { PrimoPianoSlider } from './components/primo-piano-slider';
import { Intestazione } from './components/intestazione';
import { NotizieList } from './components/notizie-list';
import { NotizieFilters } from './components/notizie-filters';
import { NotizieSlider } from './components/notizie-correlate-slider';
import { NewsDescription } from './components/news-description';
import { ContenutoRte } from './components/contenuto-rte';
import { ObbligazioniSlider } from './components/obbligazioni-slider';
import { ContactBanner } from './components/contact-banner';
import { Related } from './components/related';
import { NewsHighlightText } from './components/news-highlight-text';
import { BottomMenu } from './components/bottom-menu';
import { ObbligazioniSliderEsg } from './components/obbligazioni-slider-esg';
import { ObbligazioniTable } from './components/obbligazioni-table';
import { ObbligazioniTableFilters } from './components/obbligazioni-table-filters';
import { SpeakerSlider } from './components/speaker-slider';
import { ContenutoAccordion } from './components/contenuto-accordion';
import { NewsAuthor } from './components/news-author';
import { NewsMediaWrapper } from './components/news-media-wrapper';
import { YearListCta } from './components/year-list-cta';
import { DocumentiCorrelati } from './components/documenti-correlati';
import { MultimediaGallery } from './components/multimedia-gallery';
import { Infografica } from './components/infografica';
import { EventoCta } from './components/evento-cta';
import { Agenda } from './components/agenda';
import { EventoAgendaRte } from './components/evento-agenda-rte';
import { FondazioniList } from './components/fondazioni-list';
import { EventiList } from './components/eventi-list';
import { TimelineSlider } from './components/timeline-slider';
import { FeatureHighlights } from './components/feature-highlights';
import { GreenBondPage } from './components/green-bond-page';
import { ManagementPage } from './components/management-page';
import { EticaSlider } from './components/etica-slider';
import { RowBoxes } from './components/row-boxes';
import { RightRows } from './components/right-rows';
import { LeftTextRightSlider } from './components/left-text-right-slider';
import { SplitAccordion } from './components/split-accordion';
import { FinanziamentiSlider } from './components/finanziamenti-slider';
import { FinanziamentiDomande } from './components/finanziamenti-domande';
import { Quotes } from './components/quotes';
import { PlafondList } from './components/plafond-list';
import { FinanziamentiGaranziePage } from './components/finanziamenti-garanzie-page';
import { CardList } from './components/card-list';
import { Map } from './components/map';
import { CustomerSupport } from './components/customer-support';
import { VideoSidebar } from './components/video-sidebar';
import { DualColumnInfo } from './components/dual-column-info';
import { HighlightText } from './components/highlight-text';
import { BuoniPostali } from './components/buoni-postali';
import { ThreeBoxes } from './components/three-boxes';
import { FullWidthImage } from './components/full-width-image';
import { Stats } from './components/stats';
import { InfoRows } from './components/info-rows';
import { OverflowSlider } from './components/overflow-slider';
import { CardLinkSlider } from './components/card-link-slider';
import { FondiSlider } from './components/fondi-slider';
import { Informativa } from './components/informativa';
import { ScreenSaverOverlay } from './components/screen-saver-overlay';
import { PressRegistration } from './components/press-registration';
import { PressRegistrationExtended } from './components/press-registration-extended';
import { Datepicker } from './components/datepicker';

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit'); // eslint-disable-line global-require
}

document.addEventListener('DOMContentLoaded', () => {
  // anche se non chiami init, questo garantisce che bootstrap-italia sia incluso

  // Inizializza tutti i MediaWrapper
  document.querySelectorAll('.media-wrapper--video').forEach((el) => {
    // eslint-disable-next-line no-unused-vars
    const mediaWrapper = new MediaWrapper(el);
  });
});

// load asyncronously the SVG sprite and inject it inside the page
asyncSVG();

// initialize components
const Components = {
  header: new Header(),
  footer: new Footer(),
  cookiePreferences: new CookiePreferences(),
  pagination: new Pagination(),
  breadcrumbs: new Breadcrumbs(),
  hero: new Hero(),
  card: new Card(),
  newsEvidenza: new NewsEvidenza(),
  twoColumns: new TwoColumns(),
  contentWrapper: new ContentWrapper(),
  inEvidenza: new InEvidenza(),
  faq: new Faq(),
  storieSlider: new StorieSlider(),
  banner: new Banner(),
  multistep: new Multistep(),
  numbers: new Numbers(),
  oneColumn: new OneColumn(),
  dettaglioNews: new DettaglioNews(),
  newsDate: new NewsDate(),
  newsHeader: new NewsHeader(),
  cifre: new Cifre(),
  shareOn: new ShareOn(),
  compositionBlock: new CompositionBlock(),
  calendarCard: new CalendarCard(),
  newsletter: new Newsletter(),
  primoPianoSlider: new PrimoPianoSlider(),
  intestazione: new Intestazione(),
  notizieList: new NotizieList(),
  notizieFilters: new NotizieFilters(),
  notizieSlider: new NotizieSlider(),
  newsDescription: new NewsDescription(),
  contenutoRte: new ContenutoRte(),
  obbligazioniSlider: new ObbligazioniSlider(),
  obbligazioniSliderEsg: new ObbligazioniSliderEsg(),
  obbligazioniTable: new ObbligazioniTable(),
  obbligazioniTableFilters: new ObbligazioniTableFilters(),
  contactBanner: new ContactBanner(),
  related: new Related(),
  newsHighlightText: new NewsHighlightText(),
  bottomMenu: new BottomMenu(),
  speakerSlider: new SpeakerSlider(),
  contenutoAccordion: new ContenutoAccordion(),
  newsAuthor: new NewsAuthor(),
  newsMediaWrapper: new NewsMediaWrapper(),
  YearListCta: new YearListCta(),
  documentiCorrelati: new DocumentiCorrelati(),
  multimediaGallery: new MultimediaGallery(),
  infografica: new Infografica(),
  eventoCta: new EventoCta(),
  agenda: new Agenda(),
  eventoAgendaRte: new EventoAgendaRte(),
  fondazioniList: new FondazioniList(),
  eventiList: new EventiList(),
  timelineSlider: new TimelineSlider(),
  featureHighlights: new FeatureHighlights(),
  greenBondPage: new GreenBondPage(),
  managementPage: new ManagementPage(),
  eticaSlider: new EticaSlider(),
  rowBoxes: new RowBoxes(),
  rightRows: new RightRows(),
  leftTextRightSlider: new LeftTextRightSlider(),
  splitAccordion: new SplitAccordion(),
  finanziamentiSlider: new FinanziamentiSlider(),
  finanziamentiDomande: new FinanziamentiDomande(),
  quotes: new Quotes(),
  plafondList: new PlafondList(),
  finanziamentiGaranziePage: new FinanziamentiGaranziePage(),
  cardList: new CardList(),
  map: new Map(),
  customerSupport: new CustomerSupport(),
  videoSidebar: new VideoSidebar(),
  dualColumnInfo: new DualColumnInfo(),
  highlightText: new HighlightText(),
  buoniPostali: new BuoniPostali(),
  threeBoxes: new ThreeBoxes(),
  fullWidthImage: new FullWidthImage(),
  stats: new Stats(),
  infoRows: new InfoRows(),
  overflowSlider: new OverflowSlider(),
  cardLinkSlider: new CardLinkSlider(),
  fondiSlider: new FondiSlider(),
  informativa: new Informativa(),
  screenSaverOverlay: new ScreenSaverOverlay(),
  pressRegistration: new PressRegistration(),
  pressRegistrationExtended: new PressRegistrationExtended(),
  datepicker: new Datepicker(),
};

const PageInstance = new Page(); // must be initialized after the other components

export {
  PageInstance,
  Components,
  PageData,
  Cookies,
  Keyboard,
  Logger,
  Responsive,
  Translations,
};
